import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ReelSection } from './ReelSection';
import { reelMessages } from './reelMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole AI reel flow; each part uses its own slice of it */
import styles from './PromoteReels.module.scss';
import shared from '../../Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The longest lyrics the server takes (music24-api `REEL_LYRICS_MAX_LENGTH`). */
export const REEL_LYRICS_MAX_LENGTH = 6000;

interface ReelLyricsFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/** The optional lyrics (design a1). With no lyrics, the AI listens for them. */
const ReelLyricsFieldComponent: React.FC<ReelLyricsFieldProps> = ({ value, onChange }) => {
  const intl = useIntl();
  const label = intl.formatMessage(reelMessages.lyrics);

  const change = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => onChange(event.target.value),
    [onChange]
  );

  return (
    <ReelSection
      title={label}
      tag={intl.formatMessage(reelMessages.optional)}
      hint={intl.formatMessage(reelMessages.lyricsHint)}
    >
      <textarea
        className={styles.textarea}
        rows={4}
        value={value}
        maxLength={REEL_LYRICS_MAX_LENGTH}
        aria-label={label}
        onChange={change}
      />
      <div className={clsx(styles.count, value.length >= REEL_LYRICS_MAX_LENGTH && shared.counterOver)}>
        {intl.formatMessage(reelMessages.lyricsCount, { count: value.length, max: REEL_LYRICS_MAX_LENGTH })}
      </div>
    </ReelSection>
  );
};

export const ReelLyricsField = TypedMemo(ReelLyricsFieldComponent);
